import { render, staticRenderFns } from "./riskonemraporu.vue?vue&type=template&id=f52a8450"
import script from "./riskonemraporu.vue?vue&type=script&lang=js"
export * from "./riskonemraporu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports